import React from "react";
import useServerTable from "../../libs/useServerTable";
import { useNavigate } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Button, Box, Link, Menu, MenuItem, Checkbox, ListItemText, Typography } from "@mui/material";
import filterFactory, { dateFilter, textFilter, selectFilter, timeFilter, Comparator } from '../../libs/filter/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import moment from 'moment';
import './StudentsTable.css';
import { useState, useEffect } from "react";
import queryString from "query-string";
import { getDataTable, delete_by_token } from "../../pages/DeleteSession";
import { host } from "../../libs/webRTC";
import axios from "../../libs/httpClient";
import NavStruct from "../NavStruct";

function parseNumberOrEmpty(value) {
    if (value === "" || value === null || value === undefined) return "";
    const n = Number(value);
    return Number.isFinite(n) ? String(n) : "";
}

const FULL_TABLE_COLUMNS_STORAGE_KEY = "fullTableVisibleColumns.v1";
const FULL_TABLE_DEFAULT_VISIBLE_COLUMNS = [
    "full_name", "_id", "group", "room", "subject", "title",
    "date", "time", "webcamDuration", "screenDuration",
    "isAbsent", "outsidersInTheFrame", "isNotWatched", "suspiciousApp",
    "screencastText", "state", "pressedStartButton", "pressedEndButton",
    "isUploaded", "kurentoFailed"
];

function readVisibleColumns() {
    try {
        const raw = window.localStorage.getItem(FULL_TABLE_COLUMNS_STORAGE_KEY);
        if (!raw) return FULL_TABLE_DEFAULT_VISIBLE_COLUMNS;
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return FULL_TABLE_DEFAULT_VISIBLE_COLUMNS;
        return parsed;
    } catch {
        return FULL_TABLE_DEFAULT_VISIBLE_COLUMNS;
    }
}

function writeVisibleColumns(columns) {
    try {
        window.localStorage.setItem(FULL_TABLE_COLUMNS_STORAGE_KEY, JSON.stringify(columns));
    } catch (e) {
        console.log("failed to persist full table columns", e);
    }
}

function ScreencastTextFilter({ applyRemoteFilter, resetVersion }) {
            const [text, setText] = useState("");
            const [fromSec, setFromSec] = useState("");
            const [toSec, setToSec] = useState("");
            useEffect(() => { setText(''); setFromSec(''); setToSec(''); }, [resetVersion]);

            const applyNow = (nextText, nextFrom, nextTo) => {
                applyRemoteFilter({
                    substrings: nextText,
                    fromSec: nextFrom,
                    toSec: nextTo,

                });
            };

            const maybeAutoReset = (nextText, nextFrom, nextTo) => {
                if (!String(nextText || "").trim() && !String(nextFrom || "").trim() && !String(nextTo || "").trim()) {
                    applyNow("", "", "");
                }
            };

            const applyOnEnter = (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    applyNow(text, fromSec, toSec);
                }
            };

            return (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <input
                        className="filter text-filter form-control"
                        style={{ width: "100%" }}
                        placeholder="Enter"
                        value={text}
                        onChange={(e) => {
                            const v = e.target.value;
                            setText(v);
                            maybeAutoReset(v, fromSec, toSec);
                        }}
                        onKeyDown={applyOnEnter}
                    />
                    <div style={{ display: "flex", gap: "6px" }}>
                        <input
                            className="filter text-filter form-control"
                            style={{ width: "100%" }}
                            placeholder="от (сек)"
                            value={fromSec}
                            onChange={(e) => {
                                const v = parseNumberOrEmpty(e.target.value);
                                setFromSec(v);
                                maybeAutoReset(text, v, toSec);
                            }}
                            onKeyDown={applyOnEnter}
                        />
                        <input
                            className="filter text-filter form-control"
                            style={{ width: "100%" }}
                            placeholder="до (сек)"
                            value={toSec}
                            onChange={(e) => {
                                const v = parseNumberOrEmpty(e.target.value);
                                setToSec(v);
                                maybeAutoReset(text, fromSec, v);
                            }}
                            onKeyDown={applyOnEnter}
                        />
                    </div>
                </div>
            );
}
function createScreencastTextFilter(applyRemoteFilter) {
    return { Filter: ScreencastTextFilter, props: { applyRemoteFilter: applyRemoteFilter.apply, resetVersion: applyRemoteFilter.resetVersion } };
}

function templateColumnContent(text, dataField, sort, width, format, filter){
    const header = {
        textAlign: 'center', 
        cursor: "pointer",
        position: 'sticky', 
        top: '0', 
        backgroundColor: "#CCCCCC"
    }
    return {
        text: text,
        dataField: dataField,
        sort: sort,
        headerStyle: () => {
            return {width: width, ...header};
        },
        formatter:(cell, row, rowIndex, extraData) => {
            return format(cell, row, rowIndex, extraData);
        },
        filter: filter
    }
}

function generateLogTable(){
    const divCell = (cell) => <div class="table-cell">{cell}</div>
    const dateCell = (cell) => <div class="table-cell">{moment(cell).format('DD.MM.YY')}</div>
    const timeCell = (cell) => <div class="table-cell">{moment(cell).format('HH:mm:ss.SSS')}</div>
    return [
        templateColumnContent('Токен', '_id', true, '6%', divCell),
        templateColumnContent('Сообщение', 'message', true, '10%', divCell),
        templateColumnContent('файл', 'source', true, '6%', divCell),
        templateColumnContent('Дата', 'date', true, '8%', dateCell),
        templateColumnContent('Время', 'date', true, '8%', timeCell),
        templateColumnContent('Тип ошибки', 'type', true, '6%', divCell),
        templateColumnContent('Источник', 'device', true, '6%', divCell)
    ];
}


function generateRoomsTable() {
    const LinkCell = (cell, row) => <div class="table-cell"><Link href={row['link']}> {cell} </Link></div>;
    const divCell = (cell) => <div class="table-cell">{cell}</div>
    const dateCell = (cell) => <div class="table-cell">{moment(cell).format('DD.MM.YY')}</div>
    return [
        templateColumnContent('Название', 'title', true, '6%', LinkCell, textFilter({getFilter: (filter) => {titleFilter = filter;}})),
        templateColumnContent('Токен', '_id', true, '6%', divCell, textFilter({getFilter: (filter) => {tokenFilter = filter;}})),
        templateColumnContent('Преподаватель', 'creator', true, '6%', divCell, textFilter({getFilter: (filter) => {nameFilter = filter;}})),
        templateColumnContent('Предмет', 'subject', true, '6%', divCell, selectFilter({options: subjectOptions, getFilter: (filter) => {subjectFilter = filter;}})), 
        templateColumnContent('Дата', 'date', true, '6%', dateCell, dateFilter({getFilter: (filter) => {dataFilter = filter;}})),
        templateColumnContent('Длительность', 'duration', true, '4%', divCell, selectFilter({options: selectDuration, getFilter: (filter) => {durationFilter = filter;}})),
        templateColumnContent('Кол-во сессий', 'sessionCount', true, '4%', divCell, null),
    ];
}

function generateTable() {
    const LinkCell = (cell, row) => <div class="table-cell"><Link href={row['link']}> {cell} </Link></div>;
    const divCell = (cell) => <div class="table-cell">{cell}</div>
    const dateCell = (cell) => <div class="table-cell">{moment(cell).format('DD.MM.YY')}</div>
    const timeCell = (cell) => <div class="table-cell">{moment(cell).format('HH:mm:ss')}</div>
    return [
        templateColumnContent('ФИО студента', 'full_name', true, '10%', LinkCell, textFilter({getFilter: (filter) => {nameFilter = filter;}})),
        templateColumnContent('Токен', '_id', true, '6%', divCell, textFilter({getFilter: (filter) => {tokenFilter = filter;}})),
        templateColumnContent('Группа', 'group', true, '4%', divCell, textFilter({getFilter: (filter) => {groupFilter = filter;}})),
        templateColumnContent('Дата', 'date', true, '8%', dateCell, dateFilter({getFilter: (filter) => {dataFilter = filter;}})),
        templateColumnContent('Время (Moscow Standard Time)', 'time', true, '8%', timeCell, timeFilter({getFilter: (filter) => {timerFilter = filter;}})),
        templateColumnContent('Длительность веб-камеры', 'webcamDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {webcamDurationFilter = filter;}})),
        templateColumnContent('Длительность скринкаста', 'screenDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {screenDurationFilter = filter;}})),
        templateColumnContent('Отсутсвует в кадре', 'isAbsent', true, '5%', divCell, textFilter({getFilter: (filter) => {absentFilter = filter;}})),
        templateColumnContent('Посторонние в кадре', 'outsidersInTheFrame', true, '5%', divCell, textFilter({getFilter: (filter) => {anotherHumanFilter = filter;}})),
        templateColumnContent('Не смотрел в монитор', 'isNotWatched', true, '5%', divCell, textFilter({getFilter: (filter) => {notLookFilter = filter;}})),
        templateColumnContent('Подозрительное приложение', 'suspiciousApp', true, '7%', divCell, textFilter({getFilter: (filter) => {suspiciousAppFilter = filter;}})),
        templateColumnContent('Статус обработки', 'state', true, '5%', divCell, selectFilter({options: selectOptions, comparator: Comparator.LIKE, getFilter: (filter) => {stateFilter = filter;}})),
        templateColumnContent('Нажимал на кнопку "Начать запись"', 'pressedStartButton', true, '6%', divCell, 
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedStartButtonFilter = filter;}})),
        templateColumnContent('Завершена ли запись', 'pressedEndButton', true, '6%', divCell,
            selectFilter({options: pressedEndOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedEndButtonFilter = filter;}})),
        templateColumnContent('Видео загружено вручную', 'isUploaded', true, '6%', divCell,
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {isUploadedFilter = filter;}})),
        templateColumnContent('Ошибка kurento', 'kurentoFailed', true, '10%', divCell,
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {kurentoFailedFilter = filter;}}))
    ];
}


function generateFullTable(applyRemoteFilter) {
    const LinkCell = (cell, row) => <div class="table-cell"><Link href={row['link']}> {cell} </Link></div>;
    const divCell = (cell) => <div class="table-cell">{cell}</div>
    const dateCell = (cell) => <div class="table-cell">{moment(cell).format('DD.MM.YY')}</div>
    const timeCell = (cell) => <div class="table-cell">{moment(cell).format('HH:mm:ss')}</div>
    return [
        templateColumnContent('ФИО студента', 'full_name', true, '10%', LinkCell, textFilter({getFilter: (filter) => {nameFilter = filter;}})),
        templateColumnContent('Токен', '_id', true, '6%', divCell, textFilter({getFilter: (filter) => {tokenFilter = filter;}})),
        templateColumnContent('Группа', 'group', true, '4%', divCell, textFilter({getFilter: (filter) => {groupFilter = filter;}})),
        templateColumnContent('Комната', 'room', true, '4%', divCell, textFilter({getFilter: (filter) => {roomFilter = filter;}})),
        templateColumnContent('Предмет', 'subject', true, '6%', divCell, selectFilter({options: subjectOptions, getFilter: (filter) => {subjectFilter = filter;}})),
        templateColumnContent('Название', 'title', true, '4%', divCell, textFilter({getFilter: (filter) => {titleFilter = filter;}})),
        templateColumnContent('Дата', 'date', true, '8%', dateCell, dateFilter({getFilter: (filter) => {dataFilter = filter;}})),
        templateColumnContent('Время (Moscow Standard Time)', 'time', true, '8%', timeCell, timeFilter({getFilter: (filter) => {timerFilter = filter;}})),
        templateColumnContent('Длительность веб-камеры', 'webcamDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {webcamDurationFilter = filter;}})),
        templateColumnContent('Длительность скринкаста', 'screenDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {screenDurationFilter = filter;}})),
        templateColumnContent('Отсутсвует в кадре', 'isAbsent', true, '5%', divCell, textFilter({getFilter: (filter) => {absentFilter = filter;}})),
        templateColumnContent('Посторонние в кадре', 'outsidersInTheFrame', true, '5%', divCell, textFilter({getFilter: (filter) => {anotherHumanFilter = filter;}})),
        templateColumnContent('Не смотрел в монитор', 'isNotWatched', true, '5%', divCell, textFilter({getFilter: (filter) => {notLookFilter = filter;}})),
        templateColumnContent('Подозрительное приложение', 'suspiciousApp', true, '7%', divCell, textFilter({getFilter: (filter) => {suspiciousAppFilter = filter;}})),
        templateColumnContent('Текст скринкаста', 'screencastText', true, '12%',
            (cell, row) => <div class="table-cell"><Link href={`/table/screencastText/${row['_id']}`}>Открыть лог</Link></div>,
            createScreencastTextFilter(applyRemoteFilter)),
        templateColumnContent('Статус обработки', 'state', true, '5%', divCell, selectFilter({options: selectOptions,comparator: Comparator.LIKE,
            getFilter: (filter) => {
                stateFilter = filter;
            }
        })),
        templateColumnContent('Нажимал на кнопку "Начать запись"', 'pressedStartButton', true, '6%', divCell, 
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedStartButtonFilter = filter;}})),
        templateColumnContent('Завершена ли запись', 'pressedEndButton', true, '6%', divCell,
            selectFilter({options: pressedEndOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedEndButtonFilter = filter;}})),
        templateColumnContent('Видео загружено вручную', 'isUploaded', true, '6%', divCell,
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {isUploadedFilter = filter;}})),
        templateColumnContent('Ошибка kurento', 'kurentoFailed', true, '10%', divCell,
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {kurentoFailedFilter = filter;}}))
    ];
}

function generateTableForDeletePage() {
    const LinkCell = (cell, row) => <div class="table-cell"><Link href={row['link']}> {cell} </Link></div>;
    const divCell = (cell) => <div class="table-cell">{cell}</div>
    const dateCell = (cell) => <div class="table-cell">{moment(cell).format('DD.MM.YY')}</div>
    const timeCell = (cell) => <div class="table-cell">{moment(cell).format('HH:mm:ss')}</div>
    const buttonCell = (cell, row) => <Button variant="contained" color="error" onClick={() => { sendTokenToDelete(row) }}>Delete</Button>
    return [
        templateColumnContent('ФИО студента', 'full_name', true, '8%', LinkCell, textFilter({getFilter: (filter) => {nameFilter = filter;}})),
        templateColumnContent('Токен', '_id', true, '12%', divCell, textFilter({getFilter: (filter) => {tokenFilter = filter;}})),
        templateColumnContent('Группа', 'group', true, '4%', divCell, textFilter({getFilter: (filter) => {groupFilter = filter;}})),
        templateColumnContent('Предмет', 'subject', true, '6%', divCell, selectFilter({options: subjectOptions, getFilter: (filter) => {subjectFilter = filter;}})),
        templateColumnContent('Название', 'title', true, '4%', divCell, textFilter({getFilter: (filter) => {titleFilter = filter;}})),
        templateColumnContent('Дата', 'date', true, '8%', dateCell, dateFilter({getFilter: (filter) => {dataFilter = filter;}})),
        templateColumnContent('Время (Moscow Standard Time)', 'time', true, '8%', timeCell, timeFilter({getFilter: (filter) => {timerFilter = filter;}})),
        templateColumnContent('Длительность веб-камеры', 'webcamDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {webcamDurationFilter = filter;}})),
        templateColumnContent('Длительность скринкаста', 'screenDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {screenDurationFilter = filter;}})),
        templateColumnContent('Статус обработки', 'state', true, '5%', divCell, selectFilter({options: selectOptions,comparator: Comparator.LIKE,
            getFilter: (filter) => {
                stateFilter = filter;
            }
        })),
        templateColumnContent('Нажимал на кнопку "Начать запись"', 'pressedStartButton', true, '6%', divCell, 
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedStartButtonFilter = filter;}})),
        templateColumnContent('Завершена ли запись', 'pressedEndButton', true, '6%', divCell, 
            selectFilter({options: pressedEndOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedEndButtonFilter = filter;}})),
        templateColumnContent('   ', '', true, '6%', buttonCell)
    ];
}

function generateSimplifiedTable(changeState, selectOptionsForWeb,selectProcessingStatus) {
    const LinkCell = (cell, row) => <div class="table-cell"><Link href={row['link']}> {cell} </Link></div>;
    const divCell = (cell) => <div class="table-cell">{cell}</div>
    const dateCell = (cell) => <div class="table-cell">{moment(cell).format('DD.MM.YY')}</div>
    const timeCell = (cell) => <div class="table-cell">{moment(cell).format('HH:mm:ss')}</div>
    const imgCell = (cell) => <img
        src={(cell === 'Да' || cell === true) ? "/pic/check.png" : "/pic/cross.png"}
        alt='oops'
        width={"24px"}
        height={"24px"}
    />
    const header = {
        textAlign: 'center', 
        cursor: "pointer",
        position: 'sticky', 
        top: '0', 
        backgroundColor: "#CCCCCC"
    }
    return [
        templateColumnContent('ФИО студента', 'full_name', true, '10%', LinkCell, textFilter({getFilter: (filter) => {nameFilter = filter;}})),
        templateColumnContent('Группа', 'group', true, '4%', divCell, textFilter({getFilter: (filter) => {groupFilter = filter;}})),
        templateColumnContent('Предмет', 'subject', true, '6%', divCell, selectFilter({options: subjectOptions, getFilter: (filter) => {subjectFilter = filter;}})),
        templateColumnContent('Название', 'title', true, '4%', divCell, textFilter({getFilter: (filter) => {titleFilter = filter;}})),
        templateColumnContent('Дата', 'date', true, '8%', dateCell, dateFilter({getFilter: (filter) => {dataFilter = filter;}})),
        templateColumnContent('Время (Moscow Standard Time)', 'time', true, '8%', timeCell, timeFilter({getFilter: (filter) => {timerFilter = filter;}})),
        templateColumnContent('Нажимал на кнопку "Начать запись"', 'pressedStartButton', true, '6%', imgCell, 
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedStartButtonFilter = filter;}})),
        templateColumnContent('Завершена ли запись', 'pressedEndButton', true, '6%', imgCell,
            selectFilter({options: pressedEndOptions, comparator: Comparator.LIKE, getFilter: (filter) => {pressedEndButtonFilter = filter;}})),
        templateColumnContent('Видео загружено вручную', 'isUploaded', true, '6%', imgCell,
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {isUploadedFilter = filter;}})),
        templateColumnContent('Длительность', 'screenDuration', true, '5%', divCell, textFilter({getFilter: (filter) => {screenDurationFilter = filter;}})),
        templateColumnContent('Статус обработки', 'state', true, '5%', divCell, selectFilter({options: selectOptions,comparator: Comparator.LIKE,
            getFilter: (filter) => {
                stateFilter = filter;
            }
        })),
        {
            text: 'Нарушения веб-камеры', dataField: 'statusWebViolations', sort: true, headerStyle: (colum, colIndex) => {
                return {width: '5%', ...header};
            }, formatter: (cell, row, rowIndex, extraData) => {
                return <img src={cell} alt='oops' width={"24px"} height={"24px"} />;
            },
            events: {
                onClick: (e, column, columnIndex, row) => { changeState(row); },
            },
            style: { cursor: "pointer", textAlign: 'center', position: 'sticky' },
            filter: selectFilter({
                options: selectOptionsForWeb,
                comparator: Comparator.LIKE,
                getFilter: (filter) => {
                    statusWebViolationsFilter = filter;
                }
            })
        },
        //ToDo: Обнаружен ли телефон, добавить в будущем
        templateColumnContent('Подозрительное приложение', 'suspiciousApp', true, '7%', divCell, textFilter({getFilter: (filter) => {suspiciousAppFilter = filter;}})),
        templateColumnContent('Все ли хорошо со стороны платформы?', 'kurentoFailed', true, '6%', imgCell, 
            selectFilter({options: pressedStartButtonOptions, comparator: Comparator.LIKE, getFilter: (filter) => {kurentoFailedFilter = filter;}}))
    ];
}


const selectOptions = [
    { value: "Готово", label: 'Готово' },
    { value: "Отправлено в очередь", label: 'Отправлено в очередь' },
    { value: "Не отправлено", label: 'Не отправлено' }
];
let subjectOptions = [];

const pressedStartButtonOptions = [
    { value: "Да", label: 'Да' },
    { value: "Нет", label: 'Нет' }
];

const pressedEndOptions = [
    { value: "Да", label: 'Yes' },
    { value: "Нет", label: 'No' }
];

const selectDuration = [
    { value: "0", label: '0' },
];

// getFilter отдаёт функцию сброса, а не значение: её нужно вызвать,
// иначе фильтр остаётся применённым, а ссылка на него теряется.
const handleClick = () => {
    [
        nameFilter, tokenFilter, roomFilter, groupFilter, dataFilter,
        webcamDurationFilter, screenDurationFilter, notLookFilter, anotherHumanFilter,
        absentFilter, suspiciousAppFilter, stateFilter, statusWebViolationsFilter,
        timerFilter, subjectFilter, durationFilter, titleFilter,
        pressedStartButtonFilter, pressedEndButtonFilter, isUploadedFilter, kurentoFailedFilter
    ].forEach((clearFilter) => {
        if (typeof clearFilter === 'function') clearFilter('');
    });
    clearQueryStr();
};

let nameFilter;
let tokenFilter;
let groupFilter;
let dataFilter;
let timerFilter;
let webcamDurationFilter;
let screenDurationFilter;
let notLookFilter;
let anotherHumanFilter;
let absentFilter;
let suspiciousAppFilter;
let stateFilter;
let statusWebViolationsFilter;
let subjectFilter;
let durationFilter;
let titleFilter;
let pressedStartButtonFilter;
let pressedEndButtonFilter;
let isUploadedFilter;
let roomFilter;

let history;
let checkChanges = '';

let kurentoFailedFilter;
let arrForQueryString = {
    _id:                "",
    title:              "",
    statusWebViolations: "",
    full_name:          "",
    room:               "",
    group:              "",
    subject:            "",
    date:               {date:"",comparator:""},
    time:               {date:"",comparator:""},
    webcamDuration:     "",
    screenDuration:     "",
    isAbsent:           "",
    outsidersInTheFrame:"",
    isNotWatched:       "",
    suspiciousApp:      "",
    state:              "",
    pressedStartButton: "",
    pressedEndButton:   "",
    isUploaded:         "",
    kurentoFailed:      "",
};


function sendTokenToDelete(target) {
    console.log(target);
    delete_by_token(target._id);
}

function clearQueryStr() {
    for (let nameColumn in arrForQueryString) {
        if (nameColumn === "date" || nameColumn === "time") {
            arrForQueryString[nameColumn].date = "";
            arrForQueryString[nameColumn].comparator = "";
        } else arrForQueryString[nameColumn] = "";
    }
    console.log(window.location.pathname);
    const studentId = new URLSearchParams(window.location.search).get("studentId");
    history(window.location.pathname + (studentId ? `?studentId=${encodeURIComponent(studentId)}` : ""));
}
export function setQuerySettings(allowedFields) {
    let parsed = queryString.parse(window.location.search);
    delete parsed.studentId;
    let textFilterTemplate = {};
    for (let i in parsed) {
        if (allowedFields && !allowedFields.includes(i)) continue;
        if (typeof parsed[i] !== "string") continue;
        if (i === "timeCOMP" || i === "dateCOMP") continue;
        if (i !== "" && i !== "time" && i !== "date") {
            textFilterTemplate[i] = {
                caseSensitive: false,
                comparator: "LIKE",
                filterType: "TEXT",
                filterVal: parsed[i]
            };
        } else if (i !== "" && parsed[(i + "COMP")] !== 'null' && parsed[i] !== 'null') {

            if (i === 'time') {
                parsed[i] = parsed[i].split(/\*|GMT/);//regrex

                if (parsed[i].length === 4) {
                    parsed[i][1] = parsed[i][2];

                } else if (parsed[i].length === 2 && parsed[i][1]) {
                    if (parsed[i][1].includes('(')) {
                        parsed[i].pop();
                    }

                }
                textFilterTemplate[i] = {
                    caseSensitive: false,
                    comparator: "LIKE",
                    filterType: "TIME",
                    filterVal: {
                        date: parsed[i].length === 1 ? parsed[i][0] : { startTime: parsed[i][0], endTime: parsed[i][1] },//parsed[i].length === 1? parsed[i][0]:{start: parsed[i][0], end: parsed[i][2]},
                        comparator: parsed[(i + "COMP")],
                        queryTime: true
                    }
                };
            }

            if (i === 'date') {
                parsed[i] = parsed[i].split("*");
                textFilterTemplate[i] = {
                    caseSensitive: false,
                    comparator: "LIKE",
                    filterType: "DATE",
                    filterVal: {
                        date: parsed[i].length === 1 ? parsed[i][0] : { start: parsed[i][0], end: parsed[i][1] },
                        comparator: parsed[(i + "COMP")],
                        queryDate: true
                    }

                };
            }
        }
    }
    return textFilterTemplate;
}

export function refreshQueryString(temp) {
    let queryString = "?";
    const filterState = { ...temp };

    let currentFilter;
    for (let nameColumn in arrForQueryString) {
        currentFilter = filterState[nameColumn];
        if (typeof currentFilter !== 'undefined') { //We check that a filter has been set for this column
            if (nameColumn !== 'date' && nameColumn !== 'time') {
                if (arrForQueryString[nameColumn] !== currentFilter.filterVal) {//if the filter has not been written yet, writing
                    arrForQueryString[nameColumn] = currentFilter.filterVal;
                    queryString += nameColumn + "=" + encodeURIComponent(arrForQueryString[nameColumn]) + "&";//+ nameColumn + "COMP="+currentFilter.comparator;
                } else {
                    queryString += nameColumn + "=" + encodeURIComponent(arrForQueryString[nameColumn]) + "&";
                }
            } else {
                if (arrForQueryString[nameColumn] !== currentFilter.filterVal.date) {
                    if (nameColumn === 'time') {
                        arrForQueryString[nameColumn].comparator = currentFilter.filterVal.comparator;

                        if (arrForQueryString[nameColumn].comparator === '>= <=' && currentFilter.filterVal.date) {
                            if (currentFilter.filterVal.date[0]) {
                                arrForQueryString[nameColumn].date = currentFilter.filterVal.date[0]._d + '*' + currentFilter.filterVal.date[1]._d;
                            } else {
                                arrForQueryString[nameColumn].date = currentFilter.filterVal.date.startTime + '*' + currentFilter.filterVal.date.endTime;
                            }
                        } else {
                            arrForQueryString[nameColumn].date = currentFilter.filterVal.date;
                        }

                    }
                    if (currentFilter.filterVal.date !== 'null' && nameColumn === 'date') {
                        arrForQueryString[nameColumn].comparator = currentFilter.filterVal.comparator;
                        if (arrForQueryString[nameColumn].comparator === '>= <=' && currentFilter.filterVal.date) {
                            if (currentFilter.filterVal.date.startDate._d) {
                                arrForQueryString[nameColumn].date = currentFilter.filterVal.date.startDate._d + '*' + currentFilter.filterVal.date.endDate._d;
                            } else {
                                arrForQueryString[nameColumn].date = currentFilter.filterVal.date.startDate + '*' + currentFilter.filterVal.date.endDate;
                            }
                        } else {
                            arrForQueryString[nameColumn].date = currentFilter.filterVal.date;
                        }
                    }
                    queryString += nameColumn + "=" + encodeURIComponent(arrForQueryString[nameColumn].date) + "&" + nameColumn + "COMP=" + arrForQueryString[nameColumn].comparator + "&";

                } else queryString += nameColumn + "=" + encodeURIComponent(arrForQueryString[nameColumn].date) + "&" + nameColumn + "COMP=" + arrForQueryString[nameColumn].comparator + "&";
            }

        }
    }

    const studentId = new URLSearchParams(window.location.search).get("studentId");

    if (studentId) {
        queryString += `studentId=${encodeURIComponent(studentId)}&`;
    }

    //push in history and update temporary varibale
    if (queryString !== checkChanges) {
        console.log(window.location);
        history(window.location.pathname + queryString);
        checkChanges = queryString;
    }

}


export default function StudentsTable(props) {
    const [resetVersion, setResetVersion] = useState(0);
    const [ocr, setOcr] = useState({});
    const table = useServerTable(props.mode === 1 ? 'rooms' : props.mode === 4 ? 'logs' : 'sessions',
        { ocr, room: props.room, studentId: props.studentId, logFilters: props.logFilters }, setQuerySettings(props.mode === 4 ? [] : props.mode === 1
            ? ['_id', 'title', 'creator', 'subject', 'date', 'duration', 'sessionCount']
            : Object.keys(arrForQueryString)), 'date');
    const rowData = table.rows;
    useEffect(() => {
        if (props.mode === 5) getDataTable({ payload: table.payload, total: table.total, loading: table.loading, error: table.error });
    }, [JSON.stringify(table.payload), table.total, table.loading, table.error, props.mode]);
    const [subjects, setSubjects] = useState(null);
    const [columnsAnchorEl, setColumnsAnchorEl] = useState(null);
    const [visibleColumns, setVisibleColumns] = useState(readVisibleColumns);
    const [draftVisibleColumns, setDraftVisibleColumns] = useState(readVisibleColumns);
    const applyRemoteFilter = { apply: (payload) => { setOcr(payload); table.resetPage(); }, resetVersion };

    useEffect(() => {
        axios.get(`${host}/subjects`)
            .then((res) => setSubjects(res.data.map(e => e._id)))
            .catch((e) => console.log("failed to load subjects", e));
    }, []);

    // Генераторы колонок читают этот список на уровне модуля, поэтому он
    // пересобирается из состояния, а не дополняется push-ем один раз навсегда.
    subjectOptions = (subjects || []).map((value) => ({ value, label: value }));

    let columnDefs = [];

    switch (props.mode) {
        case 1:
            columnDefs = generateRoomsTable();
            break;
        case 2:
            columnDefs = generateTable();
            break;
        case 3:
            columnDefs = generateFullTable(applyRemoteFilter);
            break;
        case 4:
            columnDefs = generateLogTable();
            break;
        case 5:
            columnDefs = generateTableForDeletePage();
            break;
        case 6:
            columnDefs = generateSimplifiedTable(props.changeStateHandler, props.selectOptions[0], props.selectOptions[1]);
            break;
        default:
            break;
    }
    const togglableColumns = props.mode !== 3 ? [] : columnDefs
        .filter((col) => Boolean(col.dataField))
        .map((col) => ({ dataField: col.dataField, text: col.text }));

    if (props.mode === 3) {
        columnDefs = columnDefs.map((col) => (
            col.dataField
                ? { ...col, hidden: visibleColumns.indexOf(col.dataField) === -1 }
                : col
        ));
    }

    const handleColumnsMenuOpen = (event) => {
        setDraftVisibleColumns(visibleColumns);
        setColumnsAnchorEl(event.currentTarget);
    };

    const handleColumnsMenuClose = () => {
        setColumnsAnchorEl(null);
    };

    const handleToggleColumn = (event, field) => {
        // Чекбоксы не должны закрывать меню: выбор применяется только по «Сохранить».
        event.preventDefault();
        event.stopPropagation();
        setDraftVisibleColumns((current) => (
            current.indexOf(field) === -1
                ? [...current, field]
                : current.filter((item) => item !== field)
        ));
    };

    const handleSaveColumns = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        writeVisibleColumns(draftVisibleColumns);
        setVisibleColumns(draftVisibleColumns);
        setColumnsAnchorEl(null);
    };

    const changePage = () => {
        let path = document.location.pathname;
        if (path !== '/table/simplifiedTable') {
            window.location.href = '/table/simplifiedTable';
        } else {
            window.location.href = '/table/other';
        }

    };
    let path = document.location.pathname;
    history = useNavigate();
    const afterFilter = (newResult, newFilters) => {
        getDataTable(newResult);
    }
    return (
        <Box>
            <Box sx={{margin: '20px 50px 0px 50px', display: 'flex', justifyContent: 'space-between', flexWrap: 'nowrap', alignItems: 'center'}}>
                <NavStruct/>
                <Box>
                    <Button variant="contained" className="controlBtn" onClick={() => { handleClick(); setResetVersion(value => value + 1); setOcr({}); table.resetPage(); }}> Очистить все фильтры </Button>
                    {props.mode === 3 && (
                        <>
                            <Button
                                variant="contained"
                                className="controlBtn"
                                sx={{ marginLeft: "15px" }}
                                onClick={handleColumnsMenuOpen}
                            >
                                Колонки
                            </Button>
                            <Menu
                                anchorEl={columnsAnchorEl}
                                open={Boolean(columnsAnchorEl)}
                                onClose={handleColumnsMenuClose}
                                MenuListProps={{ autoFocusItem: false, sx: { pt: 0 } }}
                            >
                                <Box
                                    sx={{
                                        px: 2,
                                        py: 1.5,
                                        borderBottom: "1px solid",
                                        borderColor: "divider",
                                        position: "sticky",
                                        top: 0,
                                        bgcolor: "background.paper",
                                        zIndex: 1,
                                    }}
                                    onClick={(event) => event.stopPropagation()}
                                >
                                    <Typography variant="caption" display="block" sx={{ marginBottom: "8px" }}>
                                        Нажмите "Сохранить", чтобы применить выбранные колонки.
                                    </Typography>
                                    <Button variant="contained" size="small" fullWidth onClick={handleSaveColumns}>
                                        Сохранить
                                    </Button>
                                </Box>
                                {togglableColumns.map((col) => (
                                    <MenuItem
                                        key={col.dataField}
                                        onClick={(event) => handleToggleColumn(event, col.dataField)}
                                    >
                                        <Checkbox
                                            checked={draftVisibleColumns.indexOf(col.dataField) !== -1}
                                            tabIndex={-1}
                                            disableRipple
                                        />
                                        <ListItemText primary={col.text} />
                                    </MenuItem>
                                ))}
                            </Menu>
                        </>
                    )}
                    <Button variant="contained" className="controlBtn" sx={{ marginLeft: "15px" }} onClick={changePage}> 
                        {path === '/table' ? "Все сессии" : (path === '/table/simplifiedTable' ? 'Полная таблица' : 'Упрощённый вид таблицы')} 
                    </Button>
                </Box>
            </Box>
            <Box sx={{bgcolor: 'background.table'}}>
                {/* Initialize legacy column management before the first hidden column;
                    do not remount the table and reset its filters on each change. */}
                {table.error && <p role="alert">{table.error} <Button onClick={table.reload}>Повторить</Button></p>}
                {table.loading && <p role="status">Загрузка...</p>}
                <BootstrapTable striped hover
                    remote={{ pagination: true, filter: true, sort: true }}
                    onTableChange={(type, next) => { if (next.filters && props.mode !== 4) refreshQueryString(next.filters); table.onTableChange(type, next); }}
                    keyField={props.mode === 4 ? '_rowId' : '_id'}
                    data={rowData}
                    columns={columnDefs}
                    columnToggle={props.mode === 3 ? {} : undefined}
                    filter={filterFactory()}
                    defaultSorted={[{ dataField: "date", order: "desc" }]}
                    pagination={paginationFactory({ page: table.page, sizePerPage: table.limit, totalSize: table.total,
                        sizePerPageList: [10, 25, 50, 100], showTotal: true })}
                >

                </BootstrapTable>
            </Box>
        </Box>
    );
}
